<h1>Error</h1>
<p>Sorry, Something went wrong. We are working on it.</p>

<style type="text/scss">
  h1 {
    margin-bottom: 1rem;
  }
</style>
